import React, { useState } from 'react';
import './FabLeagueInfo.css';

const faqs = [
  {
    question: "How many seasons in FAB?",
    answer: (
      <ul>
        <li>SPRING (January Registration)</li>
        <li>SUMMER (May Registration)</li>
        <li>FALL (September Registration)</li>
      </ul>
    ),
  },
  {
    question: "When does each season start?",
    answer: (
      <p>
        Click: <a href="/fastactionbasketball/registration">Season start dates</a>
      </p>
    ),
  },
  {
    question: "How many games are there in a season?",
    answer: <p>Teams in good standing play 9-12 games including playoffs.</p>,
  },
  {
    question: "Where are the games played?",
    answer: (
      <p>
        Various facilities in LA and OC.{" "}
        <a href="/fastactionbasketball/registration">Click registration</a> to learn more.
      </p>
    ),
  },
  {
    question: "How much is it to join FAB?",
    answer: (
      <p>
        Team fee is <strong>$800</strong> (includes games, refs, mocktails, and sweat).
      </p>
    ),
  },
  {
    question: "How much is it to join FAB as a FREE AGENT?",
    answer: (
      <p>
        Free Agent fee is <strong>$100</strong>. Once placed on a team, no refunds.
      </p>
    ),
  },
  {
    question: "When are fees due?",
    answer: <p>Team fees must be paid before the first game time is released.</p>,
  },
  {
    question: "Do I have to wear a jersey?",
    answer: (
      <p>
        Yes. Light & dark sides + unique number. Discounted jerseys available from   <a href="https://www.ocimprints.com/" target="_blank" rel="noopener noreferrer">
          OC Imprints
        </a>.
      </p>
    ),
  },
  {
    question: "How do I register?",
    answer: (
      <ol>
        <li>Build a team. Choose a captain.</li>
        <li>
          Captains: complete{" "}
          <a href="https://forms.gle/9XV2uybjcEhyWgT79" target="_blank" rel="noopener noreferrer">Team Registration</a>.
        </li>
        <li>
          Players: complete{" "}
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeyQtXpllAtPRg0Ux-fujIhC3yDblZAAQZEfT_Jd-vrRnLvSw/viewform" target="_blank" rel="noopener noreferrer">Player Registration</a>.
        </li>
        <li>Pay your fee.</li>
        <li>Respect our staff (zero tolerance policy).</li>
        <li>Play your heart out.</li>
      </ol>
    ),
  },
  {
    question: "What do we get for winning the league?",
    answer: <p>FAB-designed gear you’ll want to flex daily.</p>,
  },
  {
    question: "What do we get for winning the playoffs?",
    answer: <p>FAB gear + custom championship plaque.</p>,
  },
  {
    question: "What is your refund policy?",
    answer: (
      <p>
        No team refunds after Game 1. May credit toward next season in special cases.
      </p>
    ),
  },
];

function FabLeagueInfo() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      <div className="fab_league_info_container">
        <section className="fab_intro">
          <h1>What is FAB</h1>
          <p>
            Fast Action Basketball (FAB) is a nonprofit 501(c)4 adult basketball league
            operating in multiple locations in Southern California. Our league offers
            more than just a venue for basketball; it fosters an inclusive environment
            where camaraderie, spirited competition, and community thrive.
          </p>
        </section>

        <section className="fab_faq">
          <h2>FAQs</h2>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq_item ${openIndex === index ? 'open' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <h3 className="faq_question">{faq.question}</h3>
              {openIndex === index && (
                <div className="faq_answer">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </section>
      </div>

      <div className="leagueInfo_image1">
        <div className="leagueInfo_image1-content">
          <h1>It's not about the competition...</h1>
        </div>
      </div>
      <div className="leagueInfo_image2">
        <div className="leagueInfo_image2-content">
          <h1>... it's about conquering yourself.</h1>
        </div>
      </div>
    </>
  );
}

export default FabLeagueInfo;
